import { useEffect, useRef } from 'react';

export const useAfterFirstRender = (callback: () => void) => {
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    callback();
  }, [callback]);
};

export default useAfterFirstRender;
